import { createTheme, responsiveFontSizes } from '@mui/material';

declare module '@mui/material/styles' {
  interface Palette {
    acuotaz: Palette['primary'];
  }
  interface PaletteOptions {
    acuotaz?: PaletteOptions['primary'];
  }
}

const theme = createTheme({
  palette: {
    acuotaz: {
      main: '#02b184',
      light: '#31AE78',
      dark: '#00796b',
      contrastText: '#ffffff',
    },
  },
});

export default responsiveFontSizes(theme);
